import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 2AF5ACED-6980-4A66-B010-629C3E371315
 * name book-minus-multiple-outline
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-minus-multiple-outline.svg
 * tags
 */
export const BookMinusMultipleOutlineIcon = createSvgIcon(<><path d="M13.09 20H5V6H3V20C3 21.11 3.9 22 5 22H13.81C13.44 21.39 13.2 20.71 13.09 20M19 2H9C7.9 2 7 2.9 7 4V16C7 17.11 7.9 18 9 18H13.09C13.2 17.29 13.44 16.61 13.81 16H9V4H11V10L13.5 7.75L16 10V4H19V13C19.68 13 20.36 13.11 21 13.34V4C21 2.9 20.11 2 19 2M23 18V20H15V18H23Z" /></>, 'BookMinusMultipleOutlineIcon');
export default BookMinusMultipleOutlineIcon